<template>
  <section id="navlist" class="d-flex" style="align-self: center">
    <template v-if="type == 'menu'">
      <li v-for="(data, i) in navList" :key="i" @click="(hide(data), onClickMenuOption(data))">
        <router-link
          v-if="data.type === 'route'"
          v-dataanchor
          class="scroll-link d-flex flex-column align-items-center text-center"
          tabText="dashboard"
          tagAction="click"
          tagEvent="link"
          tagSection="sidebar"
          tagType="internal link"
          :to="'/' + data.link"
          :exact="data.link === 'portal'"
        >
          <img :alt="data.link" class="mb-8 icon-bg" :src="getIcon(data.icon, data.name)" />
          <span :class="itemStyling(data.name)">{{ data.name }}</span>
        </router-link>
        <a
          v-else-if="data.type === 'modal'"
          class="scroll-link d-flex flex-column align-items-center text-center"
          :data-target="'#' + data.link"
          data-toggle="modal"
          href="#modal"
          @click="triggerModal(data)"
        >
          <img :alt="data.link" class="mb-8" :src="getIcon(data.icon)" />
          <span class="text-white font-14">{{ data.name }}</span>
        </a>
        <a
          v-else
          class="scroll-link d-flex flex-column align-items-center text-center"
          :href="data.link"
        >
          <img :alt="data.link" class="mb-8" :src="getIcon(data.icon)" />
          <span
            :class="
              data.name == this.view
                ? ' font-14 font-weight-bold dsl-yellow-btn'
                : ' font-14 text-white'
            "
          >
            {{ data.name }}
          </span>
        </a>
      </li>
    </template>
    <div v-else-if="type == 'header'">
      <div class="d-md-flex kallisto-bold align-items-center d-none">
        <span v-for="(data, i) in navList" :key="i" @click="(hide(data), onClickMenuOption(data))">
          <router-link
            v-if="data.type === 'route'"
            v-dataanchor
            class="scroll-link font-14 kallisto-bold px-1.5 mx-1.5 d-flex flex-column align-items-center text-center"
            tabText="dashboard"
            tagAction="click"
            tagEvent="link"
            tagSection="sidebar"
            tagType="internal link"
            :to="'/' + data.link"
            :exact="data.link === 'portal'"
          >
            <span :class="itemStyling(data.name)">{{ data.name }}</span>
          </router-link>
          <a
            v-else-if="data.type === 'modal'"
            class="scroll-link font-14 kallisto-bold px-1 d-flex flex-column align-items-center text-center router-link-active"
            :data-target="'#' + data.link"
            data-toggle="modal"
            href="#modal"
            @click="triggerModal(data)"
          >
            <span class="text-white">{{ data.name }}</span>
          </a>
          <a
            v-else
            class="scroll-link font-14 kallisto-bold px-1 d-flex flex-column align-items-center text-center"
            :href="data.link"
          >
            <span
              :class="data.name == this.view ? 'font-weight-bold dsl-yellow-btn' : 'text-white'"
            >
              {{ data.name }}
            </span>
          </a>
        </span>
      </div>
      <div class="d-block d-md-none px-3">
        <span class="cursor-pointer" @click="showMobileSidebar = true">
          <img alt="bars-horizontal" :src="getIcon('bars-horizontal.svg')" />
        </span>

        <Teleport to="body">
          <transition name="mobile-menu-slide">
            <div
              v-if="showMobileSidebar"
              class="mobile-menu-overlay"
              @click.self="showMobileSidebar = false"
            >
              <div class="mobile-menu-sidebar">
                <!-- Header: Logo + Close -->
                <div class="mobile-menu-sidebar__header">
                  <img
                    v-if="$store.state.role == 'admin'"
                    alt="dsl logo"
                    class="mobile-menu-sidebar__logo"
                    src="../assets/AdminLogo.png"
                  />
                  <img
                    v-else-if="$store.state.role == 'instructor'"
                    alt="dsl logo"
                    class="mobile-menu-sidebar__logo"
                    src="../assets/InstructoLogo.png"
                  />
                  <img
                    v-else-if="$store.state.role == 'pod operator'"
                    alt="dsl logo"
                    class="mobile-menu-sidebar__logo"
                    src="../assets/PodLogo.png"
                  />
                  <div v-else class="d-flex font-14 font-weight-bolder kallisto-bold text-left">
                    Dreamscape Learn Portal
                  </div>
                  <button class="mobile-menu-sidebar__close" @click="showMobileSidebar = false">
                    <img alt="close" height="12" :src="getIcon('x-button.svg')" />
                  </button>
                </div>

                <!-- Nav links -->
                <div class="mobile-menu-sidebar__nav kallisto-bold">
                  <div
                    v-for="(data, i) in navList"
                    :key="i"
                    class="mobile-menu-sidebar__nav-item"
                    :class="{ 'mobile-menu-sidebar__nav-item--first': i === 0 }"
                    @click="onMobileSidebarNav(data)"
                  >
                    <span class="mobile-menu-sidebar__nav-text">
                      {{ data.name }}
                    </span>
                  </div>
                </div>

                <!-- Footer: User info + Logout -->
                <div class="mobile-menu-sidebar__footer">
                  <div class="mobile-menu-sidebar__user">
                    <div>
                      <span
                        v-if="$store.state.role == 'admin'"
                        class="mobile-menu-sidebar__avatar"
                        style="background: #735c1d"
                      >
                        A
                      </span>
                      <span
                        v-else-if="$store.state.role == 'instructor'"
                        class="mobile-menu-sidebar__avatar"
                        style="background: #a8252f"
                      >
                        I
                      </span>
                      <span
                        v-else-if="$store.state.role == 'pod operator'"
                        class="mobile-menu-sidebar__avatar"
                        style="background: #0e4f73"
                      >
                        PO
                      </span>
                    </div>
                    <div class="mobile-menu-sidebar__user-info">
                      <p class="mb-0 font-weight-bold">
                        {{ $store.state.profile.first_name }}
                      </p>
                      <p class="mb-0 text-capitalize" style="color: #999">
                        {{ $store.state.role }}
                      </p>
                    </div>
                  </div>
                  <button class="btn p-0" @click="logoutPopup()">
                    <img alt="logout icon" height="20" src="../assets/icons/logout-svg.svg" />
                  </button>
                </div>
              </div>
            </div>
          </transition>
        </Teleport>
      </div>
    </div>
  </section>
</template>

<script>
import {
  dataLayerAnchorTag,
  dataLayerButtonTag,
  dataLayerSelectTag,
  dataLayerInputTag,
} from 'data-layer-test-oo-gtm';

export default {
  directives: {
    dataanchor: dataLayerAnchorTag,
    databutton: dataLayerButtonTag,
    'data-select': dataLayerSelectTag,
    'data-input': dataLayerInputTag,
  },
  props: {
    navList: Array,
    type: String,
  },
  data() {
    return {
      view: this.navList[0].name,
      showMobileSidebar: false,
    };
  },
  methods: {
    logoutPopup() {
      // Close mobile sidebar first so the logout modal isn't hidden behind it
      this.showMobileSidebar = false;
      // Emit event to parent to open logout modal
      this.$emit('open-logout-modal');
    },
    getImage(img) {
      return require('../assets/images/' + img + '.svg');
    },
    resolveIcon(fileName) {
      try {
        return require('@/assets/icons/' + fileName);
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn(`Icon ${fileName} missing from assets/icons, using public fallback.`);
        }
        return `${process.env.BASE_URL}img/icons/${fileName}`;
      }
    },
    triggerModal(data) {},
    getIcon(img, view) {
      const selectedIcon = img.endsWith('.svg')
        ? img.replace('.svg', '-selected.svg')
        : `${img}-selected.svg`;
      if (this.$store.state.viewFromMenu == view) {
        return this.resolveIcon(selectedIcon);
      }
      return this.resolveIcon(img);
    },
    hide(data) {
      if (data.type === 'url') {
        window.location = data.link;
      }
      this.$emit('hide');
    },
    onClickMenuOption(navListView) {
      if (navListView.type != 'modal') {
        this.$store.state.viewFromMenu = navListView.name;
        this.view = navListView.name;
      }
      // Navigate to actual routes for Scheduler and Pod Schedule
      if (navListView.name === 'Scheduler') {
        this.$router.push({ path: '/portal/scheduler' }).catch(() => {});
      } else if (navListView.name === 'Pod Schedule') {
        this.$store.state.appointmentsRefresh = false;
        const myData = {
          selected_site_id: this.$store.state.selected_site_id,
          podSessionDate: this.$store.state.podSessionDate,
        };
        this.$store.dispatch('setSchedulerSessions', myData).then(() => {
          this.$store.state.appointmentsRefresh = true;
        });
        this.$router.push({ path: '/portal/pod-schedule' }).catch(() => {});
      } else if (navListView.name === 'Dashboard') {
        this.$router.push({ path: '/portal' }).catch(() => {});
      }
      // Mobile menu will close automatically via data-bs-dismiss
    },
    onMobileSidebarNav(data) {
      this.showMobileSidebar = false;
      this.hide(data);
      this.onClickMenuOption(data);
    },
    itemStyling(view) {
      // Prioritize route path for active styling
      const currentPath = this.$route.path;

      // Check route-based matches first (takes priority over store state)
      if (view === 'Scheduler' && currentPath === '/portal/scheduler') {
        return 'font-14 font-weight-bold dsl-yellow-btn';
      }
      if (view === 'Pod Schedule' && currentPath === '/portal/pod-schedule') {
        return 'font-14 font-weight-bold dsl-yellow-btn';
      }
      if (view === 'Dashboard' && currentPath === '/portal') {
        return 'font-14 font-weight-bold dsl-yellow-btn';
      }

      // If we're on a known route, don't highlight other items based on store state
      const knownRoutes = ['/portal/scheduler', '/portal/pod-schedule', '/portal'];
      if (knownRoutes.includes(currentPath)) {
        return 'font-14 text-white';
      }

      // Fallback to store state for other routes
      if (this.$store.state.viewFromMenu === view) {
        return 'font-14 font-weight-bold dsl-yellow-btn';
      }

      return 'font-14 text-white';
    },
  },
};
</script>

<style lang="scss">
.scroll-link {
  text-decoration: none !important;
}

.scroll-link:hover,
.scroll-link:focus,
.scroll-link:active {
  text-decoration: none !important;
}

.text-white {
  padding: 6px 12px;
  color: #d0d0d0 !important;
}
.btn-signout {
  background-color: #ffc627 !important;
  border-radius: 30px !important;
}
.bt-g {
  border-top: 1px solid #323030;
}
.pod-icn,
.instructor-icn,
.admin-icn {
  border-radius: 50%;
}
.py-12 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

/* Mobile menu sidebar (teleported to body) */
.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}

.mobile-menu-sidebar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0e0e0e;
  color: #d0d0d0;
  display: flex;
  flex-direction: column;
}

.mobile-menu-sidebar__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #4c3c11;
  flex-shrink: 0;
}

.mobile-menu-sidebar__logo {
  max-width: 50%;
  height: auto;
}

.mobile-menu-sidebar__close {
  background: #333;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  min-width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.mobile-menu-sidebar__nav {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
}

.mobile-menu-sidebar__nav-item {
  padding: 16px 0;
  border-bottom: 1px solid #323030;
  cursor: pointer;
}

.mobile-menu-sidebar__nav-item--first {
  border-top: none;
}

.mobile-menu-sidebar__nav-text {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.mobile-menu-sidebar__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  margin: 0 16px 16px;
  background: #252525;
  border-radius: 8px;
  flex-shrink: 0;
}

.mobile-menu-sidebar__user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mobile-menu-sidebar__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}

.mobile-menu-sidebar__user-info {
  text-align: left;
  font-size: 14px;
  color: #fff;
}

/* Slide transition */
.mobile-menu-slide-enter-active,
.mobile-menu-slide-leave-active {
  transition: opacity 0.3s ease;
}
.mobile-menu-slide-enter-active .mobile-menu-sidebar,
.mobile-menu-slide-leave-active .mobile-menu-sidebar {
  transition: transform 0.3s ease;
}
.mobile-menu-slide-enter-from,
.mobile-menu-slide-leave-to {
  opacity: 0;
}
.mobile-menu-slide-enter-from .mobile-menu-sidebar,
.mobile-menu-slide-leave-to .mobile-menu-sidebar {
  transform: translateX(100%);
}
</style>
